import {Currency, Customer, RiskLevel, Tariff} from '../../../../../shared/api/entity';
import {Country, Money} from '../../../../../../../common/api';
import {Introducer} from '../../../+applications/new/api/entity/introducer.model';

export class CustomerProfile implements Customer {
    id: number;
    name: string;
    address: string;
    opening_date: string;
    risk_level: RiskLevel;
    tariff: Tariff;
    wlTariff: Tariff;
    authorized_user_name: string;
    phone: string;
    userEmail: string;
    email: string;
    applicationIntroducer: string;
    actualIntroducer: Introducer;
    type: number;
    state: string;
    kind: number;
    min_total_asset?: Money;
    master_account_currency?: Currency;
    country?: Country;
    approvingDate?: string;
    kyc_verification_status: string;
    negativeInterest: number;
    maxLimitAmount: number;
    closelyMonitoringAccount: boolean;
    vipHighVolumeClients: boolean;
    modulrActive: boolean;
    amlReasons: string[];
    amlPepDetails?: AmlPepDetails[];
    allLegalDocumentsVerified?: boolean;
    processedAs?: string;
    productCode?: number;
    cryptoWalletAddresses?: string[];
}

export class AmlPepDetails {
    name: string;
    type: string;
    amlPepDetailsList: string[];
}

export class ProfileState {
    id: string;
    name: string;
}

export class ProfileUserState {
    id: string;
    name: string;
}

export class ProfileType {
    id: number;
    name: string;
}

export class VerificationStatus {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/entity/customer-profile.ts